import { app } from '@/composition/app'
import { GroupState } from '@/composition/groups'
import { LearningState } from '@/composition/learning'
import { MemberStatus } from '@/models/Groups'
import { useGlobalStore } from '@/store/app'
import { AxiosError } from 'axios'

export async function initializeGroup(groupSlug: string): Promise<void> {
  try {
    const appStore = useGlobalStore()
    let locationId = appStore.$state.locationId
    await GroupState.getGroupBySlug(groupSlug)
    locationId = GroupState.state.groupData.locationId

    appStore.setLocationId(locationId)
    const groupId = GroupState.state.groupData._id
    appStore.setGroupId(groupId)
    await app.fetchUserGroups()
    if (GroupState.state?.userGroup?.contactId) {
      appStore.setUserId(GroupState.state.userGroup.contactId)
    }
    // }
    if (
      GroupState.state.groupData?.settings?.groupType != 'Private' ||
      (GroupState.state.role &&
        GroupState.state?.userStatus === MemberStatus.ACTIVE)
    ) {
      GroupState.getGroupAdmins()
      GroupState.fetchGroupMembers()
      LearningState.initializeLearningState()
    }

    // GroupState.getGroupAdmins()
  } catch (error) {
    if (!(error instanceof AxiosError && error.response?.status === 404)) {
      console.error(error)
    }
    throw error
  }
}
